import * as React from "react";

type Props = {
  pulseDuration?: number;
};

type State = {
  submitCount: number;
  pulse: boolean;
};

export const PULSE_DURATION = 1000;

export type SubmitCounterPulseWrapperInjectedProps = {
  pulse: boolean;
  incrementSubmitCount: () => void;
};

// Used to provide glow/fade error animation to forms when submit is clicked
const SubmitCounterPulseWrapperHOC = (
  WrappedComponent: React.ComponentType<any>
) => {
  return class SubmitCounterPulseWrapper extends React.PureComponent<
    Props,
    State
  > {
    state = {
      submitCount: 0,
      pulse: false
    };

    _pulseTimeout: NodeJS.Timeout | undefined;

    _incrementSubmitCount = () => {
      this.setState({
        submitCount: this.state.submitCount + 1
      });
      const pulseDuration = Number(this.props.pulseDuration) || PULSE_DURATION;

      if (!this.state.pulse) {
        this.setState({
          pulse: true
        });
        this._pulseTimeout = setTimeout(() => {
          this.setState({
            pulse: false
          });
        }, pulseDuration);
      }
    };

    componentWillUnmount() {
      clearTimeout(this._pulseTimeout!);
    }

    render() {
      return (
        <WrappedComponent
          submitCount={this.state.submitCount}
          pulse={this.state.pulse}
          incrementSubmitCount={this._incrementSubmitCount}
          {...this.props}
        />
      );
    }
  };
};

export default SubmitCounterPulseWrapperHOC;
